module.exports = __webpack_public_path__ + "media/images/6-fc55e98d.png";